<template>
    <div class="hamburger hamburger--spin" :class="rootClasses">
        <span class="hamburger--text">
            <slot/>
        </span>
        <span class="hamburger-box">
            <span class="hamburger-inner"/>
        </span>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        computed: {
            ...mapState('side-navigation', ['isOpen']),
            rootClasses() {
                // notice that the hamburger library is not BEM compatible
                return [this.isOpen ? 'is-active' : null];
            },
        },
    };
</script>
